export function ConsentCheckbox({ checked, onChange, testid, dark = false }) {
  const linkCls = dark ? "text-upland-creme hover:text-white" : "text-upland-green";
  const textCls = dark ? "text-upland-creme/80" : "text-upland-grey";
  return (
    <label className={`flex items-start gap-2.5 text-xs leading-relaxed cursor-pointer ${textCls}`}>
      <input
        type="checkbox"
        data-testid={testid}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 accent-upland-green"
      />
      <span>
        I agree to the{" "}
        <a href="/legal/terms" target="_blank" rel="noreferrer" className={`${linkCls} underline underline-offset-2`}>Terms of Service</a>{" "}
        and{" "}
        <a href="/legal/privacy" target="_blank" rel="noreferrer" className={`${linkCls} underline underline-offset-2`}>Privacy Policy</a>,
        and consent to the collection and use of my information as described.
      </span>
    </label>
  );
}
